import React from 'react';
import styles from './AdminPage.module.css';

const AdminPage = () => {
  const handleAdminAccess = () => {
    window.open('https://admin.janney.ai', '_blank');
  };

  return (
    <div className={styles['admin-page']}>
      <div className={styles['admin-content']}>
        <div className={styles['admin-info']}>
          <h3>Advanced AI Marketing Agent Access</h3>
          <p>
            This admin panel is designed specifically for marketing agencies. 
            Approved users can access our comprehensive admin dashboard to unlock 
            enhanced AI marketing agent capabilities and gain access to advanced 
            data analytics and management tools.
          </p>
          <div className={styles['features-list']}>
            <ul>
              <li>Advanced campaign analytics and insights</li>
              <li>Enhanced AI marketing agent permissions</li>
              <li>Comprehensive data management tools</li>
              <li>Agency-level reporting and monitoring</li>
              <li>Custom automation and workflow management</li>
            </ul>
          </div>
          <button 
            className={styles['access-button']}
            onClick={handleAdminAccess}
          >
            Access Admin Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
